module.exports = __webpack_public_path__ + "img/saddle-cloths-11.7beec659.svg";